import { PropsWithChildren, ReactNode } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export function ModelDialog({ children, trigger, title, description, open, onOpenChange, wide = false, editorLayout = false }: PropsWithChildren<{
  trigger?: ReactNode;
  title: string;
  description: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  wide?: boolean;
  editorLayout?: boolean;
}>) {
  return <Dialog open={open} onOpenChange={onOpenChange}>
    {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
    <DialogContent className={`max-h-[90dvh] w-[calc(100%-2rem)] rounded-2xl border-app-border bg-app-surface shadow-premium-md ${wide ? "max-w-5xl" : "max-w-xl"} ${editorLayout ? "h-[90dvh] grid-rows-[auto_minmax(0,1fr)] overflow-hidden" : "overflow-y-auto"}`} onPointerDownOutside={(event) => event.preventDefault()}>
      <DialogHeader className="pr-8 text-left">
        <DialogTitle className="font-display text-2xl text-app-fg-strong">{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>
      </DialogHeader>
      {children}
    </DialogContent>
  </Dialog>;
}
